import { JsonObject, JsonProperty } from "typescript-json-serializer";
// *Geo.js Properties*
@JsonObject()
export class LinkConfiguration {

    /**
     * Title
     */
    @JsonProperty()
    declare title: string;

    /**
     * URL
     */
    @JsonProperty()
    declare url: string;

    /**
     * CSS class
     */
    @JsonProperty()
    declare class?: string;

    constructor() {}
}
@JsonObject()
export class ConditionalLinkConfiguration extends LinkConfiguration{

    @JsonProperty()
    declare condition?: string;

    constructor() {
        super();
    }
}
